import constant from '../constant/appConst'

/**
 * Permet d'interpreter la reponse de la couche business pour traiter les erreurs sous formes d'exceptions
 */
export class BusinessResponseHandler {
	static handleResponse(response) {
		if (response) {
			if (response.code && response.code !== 200) {
				if (response.code === constant.businessLayer.code.sessionExpired) {
					// Token invalide
					// this._logout();
					throw response
				} else {
					// Le service nous renvoie une erreur
					throw response
				}
			} else {
				// reponse OK
				return response
			}
		} else {
			throw new Error('No response')
		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/BusinessResponseHandler.js